import React, {useEffect, useRef, useState} from "react";
//import { useSpring, animated, useSprings, config } from '@react-spring/web';
//import { useTransitionCarousel } from 'react-spring-carousel'
 
import BaseCard from "../Card/BaseCard";
import { cardLink, cardView } from "../../hoc/ApolloProvider";

import "./style.css";
import { animated, useSprings } from '@react-spring/web';
import { useDrag } from "@use-gesture/react";
import clamp from 'lodash.clamp'
import useResize from "../../hook/useResize";

interface FlowProps {
    flow: {
      id?: string;
      cards: Array<{ id: string, title: string; subtitle: string; data: string; category: string }>;
    };
  }

const CarouselFlow = (props: FlowProps) => {
    const { flow } = props;

    const [prevIndex, setPrevIndex] = useState(0);

    let cards:any[] = [];
    let idxList:any[] = [];

    flow.cards.map( (v,i) => {
        if( v.category === "switch" || v.category === "link" || v.category === "message" || v.category === "action" || v.category === "assess")
            if( v.subtitle === "시작")
                cards.push(v);
            else    
                cards.unshift(v);
            if( v.category === "assess" ){
              cardLink().editcardid = v.id;
            }
                return true;    
    })
    //await Promise.all(promises);
    cards.map((card, index) => {
        if( card.cardid !== null )
            idxList[ card.id] = index;
        return true;    
    })

    //let cWidth = cardView().width;
    //let cHeight = cardView().height;
    const { width : cWidth, height: cHeight } = useResize();

    const onSwitch = (cardId: any) => {
        if( cardId !== ''){
          let idx = idxList[cardId];
          //if( idx !== undefined )
          //  handleClick(idx);
        }
    }
    
    const index = useRef(0)
    const width = cWidth

    const [propsC, api] = useSprings(cards.length, i => ({
      x: i * width,
      scale: 1,
      display: 'block',
    }))

    // @ts-ignore | Weird 
    const bind = useDrag(({ active, movement: [mx], direction: [xDir], cancel }) => {
      if (active && Math.abs(mx) > width / 2) {
        index.current = clamp(index.current + (xDir > 0 ? -1 : 1), 0, cards.length - 1)
        cancel()
      }
      api.start(i => {
        if (i < index.current - 1 || i > index.current + 1) return { display: 'none' }
        const x = (i - index.current) * width + (active ? mx : 0)
        const scale = active ? 1 - Math.abs(mx) / width / 2 : 1
        return { x, scale, display: 'block' }
      })
    })
    return (
      <div className='carousel'>
        {propsC.map(({ x, display, scale }, i) => (
          <animated.div  {...bind()} key={i} style={{ display, x }}>
            <animated.div style={{ scale, }}>
            <BaseCard card={cards[i]} width={cWidth} height={cHeight}  onCaseSelect={(idx:any) => onSwitch(idx)}/>
            </animated.div>
          </animated.div>
        ))}
      </div>
    )
    /*
    const { 
      carouselFragment, 
      //slideToPrevItem, 
      //slideToNextItem 
    } = useSpringCarousel({
      itemsPerSlide: 1, 
      withLoop: true,
      items: cards.map((card) => ({
        id: card.id,
        renderItem: (
          <div style={{ width: cWidth}}>
            <BaseCard card={card} width={cWidth} height={cHeight}  onCaseSelect={(idx:any) => onSwitch(idx)}/>
          </div>
          
        ),
      })),
    });

    return (
      <div className='carousel'  style={{ position: "absolute", top:10, left:10, width: cWidth+5, height: cHeight }}>
        {carouselFragment}
      </div>
    );
    */
    
/*  
    const [activeItem, setActiveItem] = useState(0)
    const {
      carouselFragment,
      useListenToCustomEvent,
      slideToPrevItem,
      slideToNextItem
    } = useSpringCarousel({
      withLoop: true,
      items: cards.map((card,i) => ({
        id: i,
        renderItem: (
            <BaseCard card={card} width={cWidth} height={cHeight-100} onCaseSelect={(idx:any) => onSwitch(idx)}/>
        ),
      })),
    });

    useListenToCustomEvent((event) => {
      if (event.eventName === "onSlideStartChange") {
        setActiveItem(event.nextItem.index)
      } 
    });
    
    return (
      <div>
        <div>{activeItem + 1} / {cards.length}</div>
        <div>
          {carouselFragment}
        </div>
      </div>
    )
*/
}
/**
 * 
 *       <div>
        <div>{activeItem + 1} / {mockedItems.length}</div>
        <div>
          {carouselFragment}
        </div>
      </div>
 *             { cards[index].category == "switch" && <SwitchCard card={cards[index]} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
            { cards[index].category == "link" && <LinkCard card={cards[index]} onCaseSelect={(idx:any) => onSwitch(idx)}/>}
            { cards[index].category == "message" && <LinkCard card={cards[index]} onCaseSelect={(idx:any) => onSwitch(idx)}/>}


 *             onClick={() => handleClick(index)}
            { cards[index].category === "switch" &&<SwitchCard card={cards[index]} onCaseSelect={(idx:any) => onSwitch(idx)}/>}

 */
export default CarouselFlow;
